import $ from "jquery";

function hideLoadingAnimation() {
    $("#loadinganimation").fadeOut(1500);
}

setTimeout(hideLoadingAnimation, 2000);